module.exports = __webpack_public_path__ + "static/media/hand-holding-water.e0a1fd35.svg";